export default function initLoader(): void {
    document.body.addEventListener("click", e => {
        const el = (e.target as HTMLElement).closest<HTMLButtonElement>("[data-loading-text]");
        if (!el) {
            return;
        }

        el.disabled = true;
        el.innerHTML = el.dataset.loadingText!;
        document.body.classList.add("loading");
    });
}
